import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const FlexLayout = styled.div`
    display: flex;

    @media screen and (max-width: 767px) {
        flex-direction: column;
    }  
`

export const CategoryBoxWrap = styled.div``

export const NewsRowImage = styled.img`
    width: 100%;
    height: 117px;

    @media screen and (min-width: 768px) and (max-width: 1023px) {
        height: 85px;
    }

    @media screen and (max-width: 767px) {
        width: 166px;
        height: 124px;
    }

    @media screen and (max-width: 475px) {
        width: 150px;
        height: 112px;
    }

    @media screen and (max-width: 374px) {
        width: 128px;
        height: 80px;
    }
`

export const CategoryBoxRow = styled.div`
    border-right: ${({rowfirst}) => rowfirst ? '1px solid #d8d8d8':'none'};
    border-left: ${({rowfirst}) => rowfirst ? 'none':'1px solid #d8d8d8'};
    padding-right: ${({rowfirst}) => rowfirst ? '10px':'0'};
    padding-left: ${({rowfirst}) => rowfirst ? '0':'10px'};
    order: ${({rowfirst}) => rowfirst ? '0':'1'};

    @media screen and (max-width: 767px) {
        border: none;
        padding: 0;
        border-bottom: 1px dotted #d8d8d8;
    }

`

export const CategoryBoxCol = styled.div`
    padding-right: ${({rowfirst}) => rowfirst ? '0':'10px'};
    padding-left: ${({rowfirst}) => rowfirst ? '10px':'0'};
    order: ${({rowfirst}) => rowfirst ? '1':'0'};

    @media screen and (max-width: 767px) {
        padding: 0;
    }
`

export const NewsRowList = styled.ul`
    list-style: none;
    margin-top: 8px;
    width: 584px;

    @media screen and (min-width: 768px) and (max-width: 1023px) {
        width: 432px;
    }

    @media screen and (max-width: 767px) {
        width: 100%;
    }
`

export const NewsRowDesc = styled.p`
    color: #222;
    font-size: 12px;
    line-height: 1.17;
    margin-bottom: 5px;
    opacity: .7;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;

    @media screen and (max-width: 767px) {
        -webkit-line-clamp: 4;
        font-size: 14px;
        line-height: 18px;
        opacity: .8;
        margin-bottom: 4px;
    }
`

export const NewsRowItem = styled.li`
    @media screen and (max-width: 767px) {
        display: flex;
        
        &.large {
            ${NewsRowImage} {
                width: 100% !important;
                height: 219px !important;
            };
            flex-direction: column;
        }

        border-bottom: 1px solid #d8d8d8;
    }
`

export const NewsRowImageLink = styled(Link)`
    display: block;
    text-decoration: none;
`

export const NewsRowTitle  = styled(Link)`
    height: 72px;
    color: #222;
    font-size: 15px;
    font-weight: bold;
    margin: 7px 0;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;
    text-decoration: none;

    @media screen and (min-width: 768px) and (max-width: 1023px) {
        height: 56px;
        font-size: 12px;
    }

    @media screen and (max-width: 767px) {
        font-size: 20px;
        line-height: 25px;
        -webkit-line-clamp: 3;
        height: unset;
        font-weight: 500;

        &.text-4-row {
            -webkit-line-clamp: 4;
            margin-top: 0;
            font-size: 17px;
            font-weight: 500
        }
    }

    @media screen and (max-width: 374px) {
        font-size: 15px !important;
        line-height: 20px;
    }

`

export const NewsColList = styled.ul`
    list-style: none;
    margin-top: 8px;
`

export const NewsColFocusImage = styled.img`
    height: 117px;
    width: 188px;
    @media screen and (min-width: 768px) and (max-width: 1023px) {
        height: 85px;
        width: 136px;
    }

    @media screen and (max-width: 475px) {
        width: 150px;
        height: 112px;
    }

`

export const NewsColItemFocus = styled.li`
    margin-bottom: 7px;
    display: flex;
    
    @media screen and (max-width: 767px) {
        ${NewsColFocusImage} {
            width: 100%;
            height: 219px;
        }
        border-bottom: 1px solid #d8d8d8;
        flex-direction: column;
    }
`

export const NewsColFocusImageLink = styled(Link)`
    text-decoration: none;
    display: block;
`


export const NewsColFocusBody = styled.div`
    margin-left: 10px;

    @media screen and (max-width: 767px) {
        margin: 0;
    }
`

export const NewsColFocusTitle = styled(Link)`
    text-decoration: none;
    line-height: 1.29;
    color: #222;
    font-size: 15px;
    height: 54px;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;
    font-weight: bold;

    @media screen and (min-width: 768px) and (max-width: 1023px) {
        font-size: 13px;
        height: unset;
    }

    @media screen and (max-width: 767px) {
        font-size: 20px;
        line-height: 25px;
        margin: 7px 0;
        height: unset;
        font-weight: 500;
    }

`

export const NewsColFocusDesc = styled.p`
    margin-top: 8px;
    color: #222;
    font-size: 13px;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;

    @media screen and (min-width: 768px) and (max-width: 1023px) {
        margin-top: 2px;
        -webkit-line-clamp: 2;
        font-size: 12px;
    }

    @media screen and (max-width: 767px) {
        -webkit-line-clamp: 4;
        font-size: 14px;
        line-height: 18px;
        opacity: .8;
        margin-top: 0;
        margin-bottom: 4px;
    }
`

export const NewsColItem = styled.li`
    margin-bottom: 7px;
    display: flex;

    @media screen and (max-width: 767px) {
        border-bottom: 1px solid #d8d8d8;
    }
`

export const NewsColImageLink  = styled(Link)`
    display: block;
    text-decoration: none;
`

export const NewsColImage = styled.img`
    width: 90px;
    height: 55px;

    @media screen and (max-width: 767px) {
        width: 166px;
        height: 124px;
    }

    @media screen and (max-width: 374px) {
        width: 128px;
        height: 80px;
    }
`

export const NewsColBody = styled.div`
    margin-left: 8px;
`

export const NewsColTitle = styled(Link)`
    text-decoration: none;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;
    color: #222;
    line-height: 1.38;
    font-size: 14px;
    font-weight: 500;

    @media screen and (max-width: 767px) {
        -webkit-line-clamp: 4;
        margin-top: 0;
        font-size: 17px;
        font-weight: 500;
    }

    @media screen and (max-width: 374px) {
        font-size: 15px !important;
    }
`

export const NewsColCategory = styled(Link)`
    text-decoration: none;
    margin-top: 3px;
    opacity: .6;
    color: #222;
    font-size: 10px;
    text-transform: uppercase;
`

export const FlexBody = styled.div`
    display: flex;
    flex-direction: column;

    @media screen and (max-width: 767px) {
        margin-left: 10px;
    }
`